import { useMemo } from 'react';
import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { usePageBlock } from '@/data/context/pageBlock';
import { ID } from '@/data/types/Basic';
import { PLPFacetOffersChip } from '@/components/blocks/PLPFacetOffersChip';

const NullElement: React.FC = () => null;

export const PLPOfferRecommendation = ({ id }: { id: ID }) => {
	const { meta } = usePageBlock();

	const emsName = useMemo(() => {
		if (meta.tokenExternalValue) {
			return `${meta.tokenExternalValue}_ButtonsCategory`;
		}

		return 'default_ButtonsCategory';
	}, [meta.tokenExternalValue]);

	return (
		<ContentRecommendation
			id={emsName}
			properties={{
				emsName,
			}}
			loadingElement={<NullElement />}
			emptyElement={<PLPFacetOffersChip id={id} />}
		/>
	);
};
